import {
  CancellationFeeAttribution,
  type IDepositOptionText,
} from '@principle-theorem/principle-core/interfaces';

/**
 * The question the capture-strategy control asks, at both the brand and the
 * treatment-template level. Phrased as a question to match the convention the
 * ACC claim-lodgement forms use for their control groups.
 */
export const DEPOSIT_TIMING_QUESTION = 'When is the deposit taken?';

/**
 * The same question at brand level, where the answer is only a default that any
 * treatment is free to override.
 */
export const DEPOSIT_TIMING_DEFAULT_QUESTION =
  'When is a deposit taken by default?';

export const DEPOSIT_TIMING_DEFAULT_HINT = `Used for any treatment that doesn't set its own.`;

/**
 * Brand forfeiture policy. Keyed by the persisted string values rather than an
 * enum because those values are a stored contract on existing brand documents.
 */
export const DEPOSIT_FORFEITURE_POLICY_TEXT: Record<
  'auto' | 'manual',
  IDepositOptionText
> = {
  auto: {
    label: 'Forfeit automatically',
    description:
      'When a ticked reason is chosen, the deposit is forfeited and nobody is asked to confirm. Best when your rules are firm and you want them applied consistently.',
  },
  manual: {
    label: 'Ask a staff member first',
    description:
      'No money moves until someone says so. The person cancelling or rescheduling gets a deposit forfeiture control on the appointment, pre-filled from your rules, and can keep the deposit, change the amount, or waive it entirely. Best when you want room for judgement calls. ',
  },
};

export const DEPOSIT_CANCELLATION_FEE_ATTRIBUTION_TEXT: Record<
  CancellationFeeAttribution,
  IDepositOptionText
> = {
  [CancellationFeeAttribution.Practice]: {
    label: 'The practice',
    description:
      'The cancellation fee is left unallocated, so it is not counted towards any practitioner in income reports.',
  },
  [CancellationFeeAttribution.Practitioner]: {
    label: `The appointment's practitioner`,
    description:
      'The cancellation fee is credited to the practitioner the appointment was booked with, and counts towards their income.',
  },
};
